<!-- 検索バーがあるセレクトボックス -->

<search-select-edit>
  <div class="select-editable">
    <input class="form-control dummy-height" type="text" onclick="{ openMenu }" autocomplete="false"
      data-lpignore="true">
    <input class="form-control input" type="text" value="{ getCurrentLabel() }" onchange="{ props.onEditChange }"
      required="{ props.required }" autocomplete="false" data-lpignore="true">
  </div>

  <kf-menu anchor-el="{ state.menu }" open="{ !!state.menu }" on-close="{ closeMenu }" max-height="300">
    <div class="menu-search">
      <form onsubmit="{ e => e.preventDefault() }">
        <input class="form-control" type="text" oninput="{ handleFilterChange }"
          value="{ state.filter }" placeholder="検索" />
      </form>
    </div>
    <label class="menu-item { $clsx(i == state.focusedIndex && 'focus', props.getLabel(item)?.startsWith('(NG)') && 'ng-option') }" each="{ (item, i) in state.filteredList }"
      onmouseenter="{ e => handleItemMouseEnter(item, i, e) }"
      onmouseleave="{ () => props.onItemLeave?.(item) }">
      <input style="display: none;" type="checkbox" value="{ props.getId(item) }"
        onchange="{ handleCheckChange }" checked="{ props.getId(item) == props.value }" />
      { props.getLabel(item) }
    </label>
  </kf-menu>
  <script>
    import KfMenu from '@/common/components/kf-menu/kf-menu.riot';
    import { getEventValue } from '@/common/utils/dom';

    export default {
      components: {
        KfMenu,
      },
      state: {
        menu: null,
        filter: '',
        filteredList: [],
        focusedIndex: -1,
      },

      onBeforeMount() {
        this.state.filter = '';
        this.state.menu = null;
        this.state.filteredList = this.props.itemList;
        this.state.focusedINdex = -1;
      },

      handleItemMouseEnter(item, i, e) {
        this.state.focusedIndex = i;
        this.props.onItemEnter?.(item, e.currentTarget);
        this.update();
      },

      onKeyDown(e) {
        if (!['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;

        if (this.state.filteredList.length == 0) return;

        if (e.key == 'Enter') {
          if (this.state.focusedIndex == -1 || this.state.filteredList.length == 0) {
            return;
          }
          const item = this.state.filteredList[this.state.focusedIndex];

          if (item) {
            const itemId = this.props.getId(item);
            if (!this.props.unselectable || this.props.value != itemId) {
              this.props.onChange(itemId);
            } else {
              this.props.onChange('');
            }
            this.closeMenu();
            this.update();
          }
          return;
        }

        if (e.key == 'ArrowDown') {
          if (this.state.focusedIndex == this.state.filteredList.length - 1) {
            this.state.focusedIndex = 0;
          } else {
            this.state.focusedIndex += 1;
          }
        } else if (e.key == 'ArrowUp') {
          if (this.state.focusedIndex <= 0) {
            this.state.focusedIndex = this.state.filteredList.length - 1;
          } else {
            this.state.focusedIndex -= 1;
          }
        }
        const element = this.$$('.menu-item')?.[this.state.focusedIndex];
        element?.scrollIntoView({
          behavior: 'instant',
          block: 'nearest',
        });
        const item = this.state.filteredList[this.state.focusedIndex];
        if (item && element) this.props.onItemEnter?.(item, element);
        this.update();
      },

      handleFilterChange(e) {
        this.state.filter = getEventValue(e);
        if (this.state.filter == '') {
          this.state.filteredList = this.props.itemList;
        } else {
          this.state.filteredList = this.props.itemList.filter(item => this.props.checkMatch(item, this.state.filter));
        }
        this.state.focusedIndex = (this.state.filteredList.length == 0 || this.state.filter == '') ? -1 : 0;
        this.update();
      },

      handleCheckChange(e) {
        if (!this.props.unselectable || e.target.checked) {
          const value = e.target.value;
          this.props.onChange(value);
        } else {
          this.props.onChange('');
        }
        this.update();
        this.closeMenu();
      },

      openMenu(e) {
        this.state.filteredList = this.props.itemList;
        this.state.filter = '';
        this.state.focusedIndex = -1;
        this.state.menu = e.currentTarget;
        this.update();
        if (!this.isTablet) {
          const inputBar = this.$('.menu-search input[type=text]');
          inputBar.focus();
          inputBar.addEventListener('keydown', this.onKeyDown);
        }
      },

      closeMenu() {
        this.state.menu = null;
        this.state.filter = '';
        this.state.filteredList = this.props.itemList;
        this.state.focusedIndex = -1;
        this.$('.menu-search input[type=text]').removeEventListener('keydown', this.onKeyDown);
        this.props.onMenuClose?.();
        this.update();
      },

      getCurrentLabel() {
        const currentItem = this.props.itemById[this.props.value] ?? this.props.invalidItemById[this.props.value];
        return currentItem ? this.props.getLabel(currentItem) : this.props.value;
      },
    };
  </script>
  <style>

    .select-editable {
      display: block;
      position: relative;
      background-color: white;
      border: 1px solid #b6b6b6;
      border-radius: 4px;
    }

    .select-editable select {
      appearance: none;
      position: absolute;
      top: 0px;
      left: 0px;
      border: none;
      padding: 0rem 0.6rem;
      width: 100%;
      height: 100%;
      margin: 0;
    }

    .select-editable .input {
      position: absolute;
      top: 0px;
      left: 0px;
      width: calc(100% - 30px) !important;
      height: 100%;
      border: none;
      border-radius: 0;
      border-right: solid 1px rgb(196, 196, 196);
    }

    .select-editable select:focus,
    .select-editable .input:focus {
      outline: none;
    }

    .select-editable select::-ms-expand {
      display: none;
    }

    .select-editable::after {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      content: "\f0dd";
      color: #000;
      height: 100%;
      position: absolute;
      right: .7rem;
      font-size: 1.2rem;
      top: .15rem;
      pointer-events: none;
    }

    .form-control-search {
      background-color: #ffffff;
      border: 1px solid #b6b6b6;
      border-radius: 4px;
      height: 32px;
      padding: 4px 6px;
      width: 100%;
    }

    .menu-search {
      background-color: #ffffff;
      position: sticky;
      top: 0;
      box-shadow: 0px 0px 4px rgb(0, 0, 0, .6);
      padding: 4px !important;
      height: 40px;
    }

    .menu-item.focus {
      background-color: #f0f0f0;
    }

    .ng-option {
      color: #999;
    }

    .menu-item {
      height: 50px;
    }

    .menu {
      scroll-padding-block-start: 40px;
    }

    .dummy-height {
      opacity: 0;
    }
  </style>
</search-select-edit>